// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
} from '@mui/x-data-grid';
import {
    Drawer,
    Stack,
} from "@mui/material";
import Typography from "@mui/material/Typography";

// App Imports
import {getSubscriberObligationData} from "../../../ExternalData/Subscriber/SubscriberClient";
import {changeObligationHierarchy} from "../obligationHierarchySlice";


// main function
export default function WorkIssuanceObligationSubscriberGrid() {


    // ****************** BEGIN STATES ****************************

    const [subscriberData, setSubscriberData] = useState([]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCdpvId = useSelector((state) => state.obligationHierarchySlc.value.cdpvId);
    const selectorDataPointName = useSelector((state) => state.obligationHierarchySlc.value.dataPointName);
    const selectorDisplayAmount = useSelector((state) => state.obligationHierarchySlc.value.displayValue);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchSubscriberData = () =>
        getSubscriberObligationData(selectorCdpvId)

            .then(data => {
                console.log(data);
                // setDrilldownCDPVF(data);
                setSubscriberData(data);
                console.log("This is my data used for the grid rows...");
                console.log(subscriberData);
            })

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("My subscriber grid should have displayed...");
        fetchSubscriberData();
    }, [useSelector((state) => state.obligationHierarchySlc.value.subscriberGridOpen)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClose = () => {
        dispatchData(changeObligationHierarchy({subscriberGridOpen: false}));
    };


    function closeSubscriberDataDrawer() {
        dispatchData(changeObligationHierarchy({subscriberGridOpen: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchSubscriberData => [
        {    field: 'id',
            headerName: 'ID',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 60,
        },
        {
            field: 'externalId',
            headerName: 'External Id',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            // editable: true,
            width: 100,
        },
        {
            field: 'service',
            headerName: 'Service',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 150,
        },
        {
            field: 'source',
            headerName: 'Source',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 150,
        },
        {
            field: 'subCount',
            headerName: 'Count',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 150,
        },
        {
            field: 'countDate',
            headerName: 'Date',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 150,
        },

    ];

    // *************** END COLUMNS *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>

                    <GridToolbarColumnsButton />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>

            <Drawer sx={{height: "100%", width: 1600}}
                    anchor='right'
                    open={useSelector((state) => state.obligationHierarchySlc.value.subscriberGridOpen)}
                    onClose={closeSubscriberDataDrawer}
            >
                <Box>
                    <br/>
                    <h2 style={{paddingLeft: 19, cursor: 'pointer'}} onClick={() => handleClose()}>Subscriber Data</h2>
                    <br/>
                    < Stack direction="row" spacing={2}>
                        <Typography sx={{fontWeight: 'bold', pl: 3}}>Data Point</Typography>
                        <Typography>{selectorDataPointName}: {selectorDisplayAmount}</Typography>
                    </Stack>
                    <Box sx={{pl: 2}}>
                        <DataGridPro

                            style={{height: 600, width: 1000}}
                            aria-label={"SubscriberDataDrawerGrid"}
                            rows={subscriberData}
                            disableDensitySelector={true}
                            disableColumnSelector={true}
                            columns={columns(fetchSubscriberData)}
                            density={"compact"}
                            pageSize={20}
                            rowsPerPageOptions={[20]}
                            rowThreshold={0}
                            components={{
                                Toolbar: CustomToolbar,
                            }}
                        />
                    </Box>
                </Box>
            </Drawer>
        </div>
);

    // ****************** END RETURN ****************************


}



